export default "__VITE_ASSET__828e7ae1__"